function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useRef as a, useState as m } from "react";
import { getOwnerDocument as d } from '../utils/owner.js';
import { useDisposables as g } from './use-disposables.js';
import { useEvent as u } from './use-event.js';
function E(e) {
  var t = e.width / 2,
    n = e.height / 2;
  return {
    top: e.clientY - n,
    right: e.clientX + t,
    bottom: e.clientY + n,
    left: e.clientX - t
  };
}
function P(e, t) {
  return !(!e || !t || e.right < t.left || e.left > t.right || e.bottom < t.top || e.top > t.bottom);
}
function w() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$disabled = _ref.disabled,
    e = _ref$disabled === void 0 ? !1 : _ref$disabled;
  var t = a(null),
    _m = m(!1),
    _m2 = _slicedToArray(_m, 2),
    n = _m2[0],
    l = _m2[1],
    r = g(),
    o = u(function () {
      t.current = null, l(!1), r.dispose();
    }),
    f = u(function (s) {
      if (r.dispose(), t.current === null) {
        t.current = s.currentTarget, l(!0);
        {
          var i = d(s.currentTarget);
          r.addEventListener(i, "pointerup", o, !1), r.addEventListener(i, "pointermove", function (c) {
            if (t.current) {
              var p = E(c);
              l(P(p, t.current.getBoundingClientRect()));
            }
          }, !1), r.addEventListener(i, "pointercancel", o, !1);
        }
      }
    });
  return {
    pressed: n,
    pressProps: e ? {} : {
      onPointerDown: f,
      onPointerUp: o,
      onClick: o
    }
  };
}
export { w as useActivePress };